export default class PartGroup{
    id = 0;
    name = '';
}